<div class="admindash">
  <div class="admindash__header-row">
    <h1 class="admindash__header">
      {{ 'adminDash.matTab.user' | translate }}
    </h1>
    <div class="admindash__header-actions">
      <button type="button"
              class="admindash__tpl-btn"
              [attr.aria-label]="'adminDash.companies.manage' | translate"
              (click)="openCompaniesModal()">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="4" y="3" width="16" height="18" rx="2"/>
          <path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2"/>
        </svg>
        {{ 'adminDash.companies.manage' | translate }}
        <span class="admindash__tpl-pill">{{ companies.length }}</span>
      </button>

      <button type="button"
              class="admindash__tpl-btn"
              [attr.aria-label]="'adminDash.businessUnits.aria' | translate: {count: activeBuCount}"
              [matTooltip]="'adminDash.businessUnits.tooltip' | translate"
              (click)="openBuModal()">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M4 6h2M4 12h2M4 18h2M9 6h11M9 12h11M9 18h11"/>
        </svg>
        {{ 'adminDash.businessUnits.manage' | translate }}
        <span class="admindash__tpl-pill">{{ activeBuCount }}</span>
      </button>

      <button type="button"
              class="admindash__tpl-btn"
              [attr.aria-label]="'adminDash.advisors.manage' | translate"
              (click)="openAdvisorsModal()">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
        {{ 'adminDash.advisors.manage' | translate }}
        <span class="admindash__tpl-pill">{{ advisorOptions.length }}</span>
      </button>

      <button type="button"
              class="admindash__tpl-btn"
              [attr.aria-label]="'adminDash.costCalculation.open' | translate"
              (click)="openCostCalculationModal()">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
             stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M17 6.5A6 6 0 0 0 7.5 12a6 6 0 0 0 9.5 5.5"/>
          <path d="M4 10h8M4 14h8"/>
        </svg>
        {{ 'adminDash.costCalculation.manage' | translate }}
      </button>

      <button mat-flat-button class="admindash__add-user-btn" (click)="addUser()">
        {{ 'adminDash.userTable.addButton' | translate }}
      </button>
    </div>
  </div>

  <div class="au-filters">
    <div class="bf-row bf-row-top">
      <div class="search-box bench-search au-search">
        <input type="text"
               [(ngModel)]="searchTerm"
               (ngModelChange)="applyFilter()"
               [placeholder]="'adminDash.userTable.searchPlaceholder' | translate"
               [attr.aria-label]="'adminDash.userTable.searchLabel' | translate">
        <span class="search-ic" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="7"/>
            <path d="m20 20-3.5-3.5"/>
          </svg>
        </span>
      </div>

      <button type="button" class="tg-switch" role="switch"
              [class.on]="openOnly"
              [attr.aria-checked]="openOnly"
              (click)="toggleOpenOnly()">
        <span class="tg-track">
          <span class="tg-knob">
            @if (openOnly) {
              <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor"
                   stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M20 6 9 17l-5-5"/>
              </svg>
            }
          </span>
        </span>
        <span class="tg-label">{{ 'adminDash.userTable.inactiveUsers' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="admindash__chip-row">
  <div class="admindash__company-chips" role="group"
       [attr.aria-label]="'adminDash.userTable.companyFilter' | translate">
    <button type="button"
            class="admindash__fchip"
            [ngClass]="{'admindash__fchip--on': selectedCompany === 'ALL'}"
            [attr.aria-pressed]="selectedCompany === 'ALL'"
            (click)="onCompanyFilterChange('ALL')">
      {{ 'adminDash.userTable.allCompanies' | translate }}
    </button>
    @for (company of companies; track company.id) {
      <button type="button"
              class="admindash__fchip"
              [ngClass]="{ 'admindash__fchip--on': selectedCompany === company.abbreviation && !company.color }"
              [style]="chipStyle(company.color, selectedCompany === company.abbreviation)"
              [attr.aria-pressed]="selectedCompany === company.abbreviation"
              [matTooltip]="company.name"
              (click)="onCompanyFilterChange(company.abbreviation)">
        {{ company.abbreviation }}
      </button>
    }
    <button type="button"
            class="admindash__fchip"
            [ngClass]="{'admindash__fchip--on': selectedCompany === 'NONE'}"
            [attr.aria-pressed]="selectedCompany === 'NONE'"
            (click)="onCompanyFilterChange('NONE')">
      {{ 'adminDash.userTable.noCompany' | translate }}
    </button>
  </div>

  <span class="admindash__chip-sep" aria-hidden="true">|</span>

  <div class="admindash__role-chips" role="group"
       [attr.aria-label]="'adminDash.userTable.roleFilter' | translate">
    <button type="button"
            class="admindash__fchip"
            [ngClass]="{'admindash__fchip--on': selectedRole === 'ALL'}"
            [attr.aria-pressed]="selectedRole === 'ALL'"
            (click)="onRoleFilterChange('ALL')">
      {{ 'adminDash.userTable.allRoles' | translate }}
    </button>
    @for (role of roleFilterOptions; track role) {
      <button type="button"
              class="admindash__fchip"
              [ngClass]="{'admindash__fchip--on': selectedRole === role}"
              [attr.aria-pressed]="selectedRole === role"
              (click)="onRoleFilterChange(role)">
        {{ ('adminDash.userTable.roleChips.' + role) | translate }}
      </button>
    }
  </div>
  </div>

  <div class="bench-summary">
    <b>{{ paginatedUsers.length }}</b> {{ 'adminDash.userTable.summary' | translate: {total: filteredUsers.length} }}
  </div>

  @if (selectedUserIds.size > 0) {
    <div class="au-bulk">
      <span class="au-bulk-n">{{ 'adminDash.userTable.bulk.count' | translate: {count: selectedUserIds.size} }}</span>
      <span class="au-bulk-lbl">{{ 'adminDash.userTable.bulk.label' | translate }}</span>
      <select class="bf-input au-bulk-sel"
              [(ngModel)]="bulkAdvisorId"
              [attr.aria-label]="'adminDash.userTable.bulk.selectAria' | translate">
        <option value="">— {{ 'adminDash.userTable.bulk.choose' | translate }} —</option>
        @for (a of bulkAdvisorOptions(); track a.id) {
          <option [value]="a.id">{{ a.abbreviation ? a.abbreviation + ' — ' : '' }}{{ a.firstName }} {{ a.lastName }}</option>
        }
      </select>
      <button class="btn-primary au-bulk-go" type="button"
              [disabled]="!bulkAdvisorId"
              (click)="applyBulkAdvisor()">
        {{ 'adminDash.userTable.bulk.apply' | translate }}
      </button>
      @if (bulkAdvisorOptions().length === 0) {
        <span class="au-bulk-hint">{{ 'adminDash.userTable.bulk.noneFit' | translate }}</span>
      }
      <button class="btn-text au-bulk-x" type="button" (click)="clearSelection()">
        {{ 'adminDash.userTable.bulk.clear' | translate }}
      </button>
    </div>
  }

  <div class="au-table-wrap">
    <table class="au-table">
      <!-- NP20-917: feste Spaltenbreiten. Ohne sie rechnet der Browser die Breiten bei
           jeder Sortierung neu, weil andere Zeilen auf der Seite stehen. Benutzer,
           E-Mail, Betreuer und Rollen bleiben elastisch und teilen den Restplatz. -->
      <colgroup>
        <col class="au-col-cbx">
        <col>
        <col class="au-col-kuerzel">
        <col>
        <col class="au-col-firma">
        <col class="au-col-konto">
        <col class="au-col-angenommen">
        <col>
        <col>
        <col class="au-col-kosten">
        <col class="au-col-aktionen">
      </colgroup>
      <thead>
        <tr>
          <th class="au-cbx-th">
            <input type="checkbox" class="au-cbx"
                   [checked]="isAllSelected()"
                   (change)="toggleSelectAll($event)"
                   [attr.aria-label]="'adminDash.userTable.bulk.selectAll' | translate">
          </th>
          <th scope="col" class="au-sort" tabindex="0"
              [class.au-sort--on]="sortKey === 'user'"
              [attr.aria-sort]="ariaSort('user')"
              [attr.aria-label]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.col.user' | translate)}"
              [title]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.col.user' | translate)}"
              (click)="onSort('user')"
              (keydown)="onSortKeydown($event, 'user')">
            {{ 'adminDash.userTable.col.user' | translate }}
            <span class="au-sort-ind" aria-hidden="true">{{ sortIndicator('user') }}</span>
          </th>
          <th scope="col" class="au-sort" tabindex="0"
              [class.au-sort--on]="sortKey === 'abbreviation'"
              [attr.aria-sort]="ariaSort('abbreviation')"
              [attr.aria-label]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.abbreviation' | translate)}"
              [title]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.abbreviation' | translate)}"
              (click)="onSort('abbreviation')"
              (keydown)="onSortKeydown($event, 'abbreviation')">
            {{ 'adminDash.userTable.abbreviation' | translate }}
            <span class="au-sort-ind" aria-hidden="true">{{ sortIndicator('abbreviation') }}</span>
          </th>
          <th scope="col" class="au-sort" tabindex="0"
              [class.au-sort--on]="sortKey === 'email'"
              [attr.aria-sort]="ariaSort('email')"
              [attr.aria-label]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.email' | translate)}"
              [title]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.email' | translate)}"
              (click)="onSort('email')"
              (keydown)="onSortKeydown($event, 'email')">
            {{ 'adminDash.userTable.email' | translate }}
            <span class="au-sort-ind" aria-hidden="true">{{ sortIndicator('email') }}</span>
          </th>
          <th scope="col" class="au-sort" tabindex="0"
              [class.au-sort--on]="sortKey === 'company'"
              [attr.aria-sort]="ariaSort('company')"
              [attr.aria-label]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.col.company' | translate)}"
              [title]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.col.company' | translate)}"
              (click)="onSort('company')"
              (keydown)="onSortKeydown($event, 'company')">
            {{ 'adminDash.userTable.col.company' | translate }}
            <span class="au-sort-ind" aria-hidden="true">{{ sortIndicator('company') }}</span>
          </th>
          <th scope="col" class="au-sort" tabindex="0"
              [class.au-sort--on]="sortKey === 'account'"
              [attr.aria-sort]="ariaSort('account')"
              [attr.aria-label]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.col.account' | translate)}"
              [title]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.col.account' | translate)}"
              (click)="onSort('account')"
              (keydown)="onSortKeydown($event, 'account')">
            {{ 'adminDash.userTable.col.account' | translate }}
            <span class="au-sort-ind" aria-hidden="true">{{ sortIndicator('account') }}</span>
          </th>
          <th scope="col" class="au-sort" tabindex="0"
              [class.au-sort--on]="sortKey === 'accepted'"
              [attr.aria-sort]="ariaSort('accepted')"
              [attr.aria-label]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.active' | translate)}"
              [title]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.active' | translate)}"
              (click)="onSort('accepted')"
              (keydown)="onSortKeydown($event, 'accepted')">
            {{ 'adminDash.userTable.active' | translate }}
            <span class="au-sort-ind" aria-hidden="true">{{ sortIndicator('accepted') }}</span>
          </th>
          <th scope="col" class="au-sort" tabindex="0"
              [class.au-sort--on]="sortKey === 'advisor'"
              [attr.aria-sort]="ariaSort('advisor')"
              [attr.aria-label]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.advisor' | translate)}"
              [title]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.advisor' | translate)}"
              (click)="onSort('advisor')"
              (keydown)="onSortKeydown($event, 'advisor')">
            {{ 'adminDash.userTable.advisor' | translate }}
            <span class="au-sort-ind" aria-hidden="true">{{ sortIndicator('advisor') }}</span>
          </th>
          <th scope="col">{{ 'adminDash.userTable.roles' | translate }}</th>
          <th scope="col" class="au-r au-sort" tabindex="0"
              [class.au-sort--on]="sortKey === 'cost'"
              [attr.aria-sort]="ariaSort('cost')"
              [attr.aria-label]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.cost' | translate)}"
              [title]="'adminDash.userTable.sortBy' | translate: {column: ('adminDash.userTable.cost' | translate)}"
              (click)="onSort('cost')"
              (keydown)="onSortKeydown($event, 'cost')">
            {{ 'adminDash.userTable.cost' | translate }}
            <span class="au-sort-ind" aria-hidden="true">{{ sortIndicator('cost') }}</span>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (user of paginatedUsers; track user.id) {
          <tr [class.au-offen]="isOpenRegistration(user)"
              [class.au-sel-row]="user.id && selectedUserIds.has(user.id)">
            <td class="au-cbx-td">
              <input type="checkbox" class="au-cbx"
                     [checked]="!!user.id && selectedUserIds.has(user.id)"
                     (change)="toggleSelectUser(user, $event)"
                     [attr.aria-label]="'adminDash.userTable.bulk.selectRow' | translate: {name: (user.firstName || '') + ' ' + (user.lastName || '')}">
            </td>
            <td>
              <div class="au-name" [title]="(user?.firstName || '') + ' ' + (user?.lastName || '')">{{ user?.firstName }} {{ user?.lastName }}</div>
              @if (isOpenRegistration(user)) {
                <div class="au-sub">{{ 'adminDash.userTable.openRegistration' | translate }}</div>
              }
            </td>
            <td>
              @if (user?.abbreviation) {
                <span class="au-kuerzel">{{ user.abbreviation }}</span>
              } @else {
                <span class="muted-dash">—</span>
              }
            </td>
            <td>
              <span class="au-mail" [title]="user?.email ?? ''">{{ user?.email }}</span>
            </td>
            <td>
              @if (user?.firma; as firma) {
                <span class="au-firma-badge"
                      [ngStyle]="companyBadgeStyleOf(firma)"
                      [title]="companyNameOf(firma)">
                  {{ firma }}
                </span>
              } @else {
                <span class="au-nofirma">{{ 'adminDash.userTable.noCompany' | translate }}</span>
              }
            </td>
            <td>
              @if (user?.consultantId) {
                <span class="au-ok">{{ 'adminDash.userTable.isLinked' | translate }}</span>
              } @else {
                <span class="au-no">{{ 'adminDash.userTable.accountOpen' | translate }}</span>
              }
            </td>
            <td>
              @if (checkStatus(user)) {
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#2E9E44"
                     stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"
                     [attr.aria-label]="'adminDash.userTable.accepted' | translate">
                  <path d="M20 6 9 17l-5-5"/>
                </svg>
              } @else {
                <span class="muted-dash">—</span>
              }
            </td>
            <td>
              @if (user?.superVisor?.firstName || user?.superVisor?.lastName) {
                <span class="au-btr-name-only"
                      [title]="(user.superVisor.firstName || '') + ' ' + (user.superVisor.lastName || '')">{{ user.superVisor.firstName }} {{ user.superVisor.lastName }}</span>
              } @else {
                <span class="au-nofirma">{{ 'adminDash.userTable.noAdvisor' | translate }}</span>
              }
            </td>
            <td>
              @if (user?.authorities?.length) {
                <div class="au-roles-cell">
                  @for (auth of user.authorities; track auth.name) {
                    <span class="au-role-badge">{{ auth.name }}</span>
                  }
                </div>
              } @else {
                <span class="muted-dash">—</span>
              }
            </td>
            <td class="au-r">
              @if (user?.cost != null) {
                <span class="au-kosten">{{ user.cost }}</span>
              } @else {
                <span class="muted-dash">—</span>
              }
            </td>
            <td>
              <div class="au-actions">
                @if (user?.consultantId) {
                  <button type="button" class="of-del"
                          [title]="'adminDash.userTable.uploadCv' | translate"
                          [attr.aria-label]="'adminDash.userTable.uploadCv' | translate"
                          (click)="openCvUpload(user)">
                    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
                         stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/>
                      <path d="M14 3v5h5"/>
                      <path d="M12 18v-6M9 15l3-3 3 3"/>
                    </svg>
                  </button>
                }
                <button type="button" class="of-del"
                        [title]="'adminDash.userTable.editUser' | translate"
                        [attr.aria-label]="'adminDash.userTable.editUser' | translate"
                        (click)="editUser(user)">
                  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
                       stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M12 20h9"/>
                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4z"/>
                  </svg>
                </button>
                <button type="button" class="of-del"
                        [title]="'adminDash.userTable.deleteUser' | translate"
                        [attr.aria-label]="'adminDash.userTable.deleteUser' | translate"
                        (click)="selectDeleteUser(user)">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                       stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M4 7h16M10 11v6M14 11v6"/>
                    <path d="M6 7l1 13a2 2 0 002 2h6a2 2 0 002-2l1-13"/>
                    <path d="M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        }
        @if (!paginatedUsers.length) {
          <tr>
            <td colspan="11" class="au-empty">{{ 'adminDash.userTable.empty' | translate }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <mat-paginator
    class="admindash__paginator"
    [length]="filteredUsers.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 50, filteredUsers.length]"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)"
    [attr.aria-label]="'adminDash.userTable.paginatorLabel' | translate"
  >
  </mat-paginator>

  @if (userModalOpen && userDraft) {
    <div class="modal-overlay" (mousedown)="closeUserModal()">
      <div class="modal-card ue-card" role="dialog" aria-modal="true"
           aria-labelledby="user-modal-title"
           (mousedown)="$event.stopPropagation()"
           cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.escape)="closeUserModal()">
        <div class="modal-head">
          <div>
            <div class="modal-sub">{{ 'adminDash.userModal.sub' | translate }}</div>
            <div class="modal-title" id="user-modal-title">
              {{ (userModalMode === 'edit' ? 'adminDash.userModal.editTitle' : 'adminDash.userModal.addTitle') | translate }}
            </div>
          </div>
          <button class="modal-x" type="button" [attr.aria-label]="'general.close' | translate" (click)="closeUserModal()">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
                 stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M6 6l12 12M18 6l-12 12"/>
            </svg>
          </button>
        </div>

        <div class="modal-body">
          <div class="ue-grid">
            <label class="bf-field">
              <span class="bf-label">{{ 'adminDash.userModal.firstName' | translate }} *</span>
              <input class="bf-input" type="text" [(ngModel)]="userDraft.firstName" required>
            </label>

            <label class="bf-field">
              <span class="bf-label">{{ 'adminDash.userModal.lastName' | translate }} *</span>
              <input class="bf-input" type="text" [(ngModel)]="userDraft.lastName" required>
            </label>

            <label class="bf-field ue-wide">
              <span class="bf-label">{{ 'adminDash.userModal.email' | translate }} *</span>
              <input class="bf-input" type="email" [(ngModel)]="userDraft.email" required>
            </label>

            <!-- NP20-772: Das Kuerzel vergibt das Backend. Beim Anlegen gibt es das Feld deshalb nicht,
                 beim Bearbeiten zeigt es den vergebenen Wert nur an. -->
            @if (userModalMode === 'edit') {
              <label class="bf-field">
                <span class="bf-label">{{ 'adminDash.userModal.abbreviation' | translate }}</span>
                <input class="bf-input" type="text" [ngModel]="userDraft.abbreviation" readonly
                       [attr.aria-readonly]="true">
                <span class="bf-note">{{ 'adminDash.userModal.abbreviationNote' | translate }}</span>
              </label>
            }

            <label class="bf-field">
              <span class="bf-label">{{ 'adminDash.userModal.cost' | translate }}</span>
              <input class="bf-input" type="number" min="0" placeholder="—"
                     [(ngModel)]="userDraft.cost">
            </label>

            <label class="bf-field">
              <span class="bf-label">{{ 'adminDash.userModal.company' | translate }} *</span>
              <select class="bf-input" [ngModel]="formFirma" (ngModelChange)="onFormFirmaChange($event)" required>
                <option [ngValue]="null" disabled>{{ 'adminDash.userModal.noCompany' | translate }}</option>
                @for (c of companies; track c.id) {
                  <option [ngValue]="c.abbreviation">{{ c.abbreviation }} — {{ c.name }}</option>
                }
              </select>
            </label>

            <label class="bf-field">
              <span class="bf-label">{{ 'adminDash.userModal.language' | translate }} *</span>
              <select class="bf-input" [(ngModel)]="userDraft.langKey" required>
                <option value="de">{{ 'registerModal.formField.german' | translate }}</option>
                <option value="en">{{ 'registerModal.formField.english' | translate }}</option>
              </select>
            </label>

            <label class="bf-field">
              <span class="bf-label">{{ 'adminDash.userModal.advisor' | translate }} *</span>
              <select class="bf-input"
                      [ngModel]="userDraft.superVisor?.id ?? null"
                      (ngModelChange)="onFormAdvisorChange($event)"
                      required>
                <option [ngValue]="null" disabled>{{ 'adminDash.userModal.noAdvisor' | translate }}</option>
                @for (a of advisorSelectOptions(); track a.id) {
                  <option [ngValue]="a.id">
                    {{ a.abbreviation ? a.abbreviation + ' — ' : '' }}{{ a.firstName }} {{ a.lastName }}
                    @if (!advisorLeadsSelectedFirma(a)) {
                      · {{ 'adminDash.userModal.advisorNotLeading' | translate }}
                    }
                  </option>
                }
              </select>
              @if (formFirma && advisorsForFirma().length === 0) {
                <span class="bf-hint">{{ 'adminDash.userModal.noAdvisorForCompany' | translate }}</span>
              }
            </label>

            <!-- Rollen vergibt nur der Admin. Beim Anlegen gibt es sie fuer niemanden mehr —
                 das Backend setzt fix die Rolle User. Fuer Nicht-Admins sind sie im Bearbeiten-Modal
                 nur lesbare Badges, also weder klickbar noch per Tab erreichbar. -->
            <div class="bf-field ue-wide">
              <span class="bf-label" id="ue-rollen-label">{{ 'adminDash.userModal.roles' | translate }}</span>
              @if (userModalMode === 'add') {
                <div class="ue-rollen" role="group" aria-labelledby="ue-rollen-label"
                     aria-describedby="ue-rollen-note">
                  <span class="au-role-badge">{{ defaultRole }}</span>
                </div>
                <span class="bf-note" id="ue-rollen-note">{{ 'adminDash.userModal.rolesOnCreateNote' | translate }}</span>
              } @else if (canEditRoles) {
                <div class="ue-rollen" role="group" aria-labelledby="ue-rollen-label">
                  @for (role of roleOrder; track role) {
                    <button type="button" class="au-role"
                            [class.on]="hasRole(role)"
                            [attr.aria-pressed]="hasRole(role)"
                            (click)="toggleRole(role)">
                      {{ role }}
                    </button>
                  }
                </div>
              } @else {
                @if (userDraft.authorities?.length) {
                  <div class="ue-rollen" role="group" aria-labelledby="ue-rollen-label"
                       aria-describedby="ue-rollen-note">
                    @for (auth of draftRolesInOrder; track auth.name) {
                      <span class="au-role-badge">{{ auth.name }}</span>
                    }
                  </div>
                }
                <span class="bf-note" id="ue-rollen-note">{{ 'adminDash.userModal.rolesAdminOnlyNote' | translate }}</span>
              }
            </div>

            <div class="ue-switches">
              <button type="button" class="tg-switch" role="switch"
                      [class.on]="userDraft.status === 'ACTIVE'"
                      [attr.aria-checked]="userDraft.status === 'ACTIVE'"
                      (click)="toggleAccepted()">
                <span class="tg-track">
                  <span class="tg-knob">
                    @if (userDraft.status === 'ACTIVE') {
                      <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor"
                           stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M20 6 9 17l-5-5"/>
                      </svg>
                    }
                  </span>
                </span>
                <span class="tg-label">{{ 'adminDash.userModal.accepted' | translate }}</span>
              </button>

              <div class="ue-ro" [title]="'adminDash.userModal.accountReadOnlyHint' | translate">
                <span class="bf-label">{{ 'adminDash.userModal.account' | translate }}</span>
                @if (userDraft.consultantId) {
                  <span class="au-ok">{{ 'adminDash.userTable.isLinked' | translate }}</span>
                } @else {
                  <span class="au-no">{{ 'adminDash.userModal.notConnected' | translate }}</span>
                }
                <span class="ue-ro-hint">{{ 'adminDash.userModal.fromBackend' | translate }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-foot">
          <span class="modal-count">{{ 'adminDash.userModal.requiredHint' | translate }}</span>
          <div class="modal-actions">
            <button class="btn-text" type="button" (click)="closeUserModal()">{{ 'general.cancel' | translate }}</button>
            <button
              class="btn-primary"
              type="button"
              [disabled]="!isUserFormValid || isAddingUser"
              (click)="saveUser()"
            >
              {{ 'general.save' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }


  <app-modal
    modalId="deleteUser"
    (save)="deleteUser(selectedUser)"
    [title]="'adminDash.deleteModal.header'"
    [text]="'adminDash.deleteModal.subheader'"
    [(visible)]="showDeleteModal"
    [showButtons]="true"
    (cancel)="closeDeleteModal()"
    [showClose]="true"
    [contentTemplate]="deleteUserTemplate"
    [saveText]="'general.delete'"
  >
  </app-modal>

  <ng-template #deleteUserTemplate>
    <p>{{ selectedUser?.firstName }} {{ selectedUser?.lastName }}</p>
  </ng-template>

  <app-companies-modal
    [visible]="companiesModalOpen"
    (visibleChange)="onCompaniesModalVisibleChange($event)"
    (saved)="onCompaniesSaved($event)">
  </app-companies-modal>

  <app-advisors-modal
    [visible]="advisorsModalOpen"
    (visibleChange)="onAdvisorsModalVisibleChange($event)"
    (saved)="onAdvisorsSaved($event)">
  </app-advisors-modal>

  <app-cost-calculation-modal
    [visible]="costCalculationModalOpen"
    (visibleChange)="onCostCalculationModalVisibleChange($event)">
  </app-cost-calculation-modal>

  <app-bu-catalog-modal
    [visible]="buModalOpen"
    (visibleChange)="onBuModalVisibleChange($event)"
    (saved)="onBuSaved($event)">
  </app-bu-catalog-modal>
</div>
